const C = "HISTORY_SHIP_OUT";

export default {
    CHANGE_DISPLAY_LIST: `${C}_CHANGE_DISPLAY_LIST`,
    CHANGE_PAGING_TOTAL: `${C}_CHANGE_PAGING_TOTAL`,
    CHANGE_PAGING_CURRENT: `${C}_CHANGE_PAGING_CURRENT`,
    CHANGE_SELECTED_FILTER: `${C}_CHANGE_SELECTED_FILTER`,
    CHANGE_SEARCH_VALUE: `${C}_CHANGE_SEARCH_VALUE`,
    CHANGE_SEARCH_STATUS: `${C}_CHANGE_SEARCH_STATUS`,
}